import {Component, OnInit} from '@angular/core';


@Component({
    selector: 'cookie-popup',
    imports: [],
    templateUrl: './cookie-popup.component.html',
    styleUrl: './cookie-popup.component.scss'
})
export class CookiePopupComponent implements OnInit{
  showBanner: boolean = false;

  ngOnInit(): void {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      this.showBanner = true;
    }
  }

  acceptCookies(): void {
    localStorage.setItem('cookieConsent', 'true');
    this.showBanner = false;
  }
}

